import './FaceLabel.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Colors } from '@fifth-gear-tech/common-components/dist/utils/StyledTheme';
import { RadioGroup } from '@fifth-gear-tech/common-components/dist/components';

import { IS_BAD_CHROME, LABEL_SIZE_MAP } from '../../constants';
import { FourByEightLabel, FourByOneLabel, FourBySixLabel, FourByThreeLabel, RemnantLabel } from '../../labels';

/**
 * FaceLabel Component
 * @augments {Component<Props, State>}
 */
class FaceLabel extends Component {
    buildContainer = () => {
        const { size, qrCodeLabelsDisabled } = this.props;

        switch (size) {
            case LABEL_SIZE_MAP._4x8:
                return (<FourByEightLabel {...this.props} qrDisabled={qrCodeLabelsDisabled[LABEL_SIZE_MAP._4x8]} />);
            case LABEL_SIZE_MAP._4x6:
                return (<FourBySixLabel {...this.props} qrDisabled={qrCodeLabelsDisabled[LABEL_SIZE_MAP._4x6]} />);
            case LABEL_SIZE_MAP._4x3:
                return (<FourByThreeLabel {...this.props} qrDisabled={qrCodeLabelsDisabled[LABEL_SIZE_MAP._4x3]} />);
            case LABEL_SIZE_MAP._4x1:
                return (<FourByOneLabel {...this.props} qrDisabled={qrCodeLabelsDisabled[LABEL_SIZE_MAP._4x1]} />);
            case LABEL_SIZE_MAP.REMNANT:
                return (<RemnantLabel {...this.props} />);
            default:
                return null;
        }
    }

    render() {
        const { size, onSizeChange, allowSizeChange } = this.props;
        return (
            <div className={'FaceLabel'}>

                {([LABEL_SIZE_MAP._4x8, LABEL_SIZE_MAP._4x6, LABEL_SIZE_MAP._4x3, LABEL_SIZE_MAP._4x1].includes(size) && allowSizeChange) &&
                    <div className={'selector'}>
                        <p><em>Label Size</em></p>
                        <RadioGroup
                            value={size}
                            options={IS_BAD_CHROME ? ['4x8', '4x6', '4x1'] : ['4x8', '4x6', '4x3', '4x1']}
                            onValueChange={onSizeChange}
                            colorTheme={Colors.Orange}
                        />

                    </div>
                }

                {size === LABEL_SIZE_MAP.REMNANT &&
                    <div className={'remnant-label'} >
                        <p><em>Remnant Label</em></p>
                    </div>
                }

                <div className={'container'}>
                    {this.buildContainer()}
                </div>
                <div className={'padding'} />
            </div >
        );
    }
}


FaceLabel.defaultProps = {
    size: LABEL_SIZE_MAP.DEFAULT,
    allowSizeChange: true,
    onSizeChange: () => { },
    qrCodeLabelsDisabled: {}
};

FaceLabel.propTypes = {
    allowSizeChange: PropTypes.bool,
    size: PropTypes.string,
    onSizeChange: PropTypes.func,
    qrCodeLabelsDisabled: PropTypes.object
};

export default FaceLabel;
